@if (show.loading) {
  <div class="flex flex-col gap-y-[1.25rem]">
    <app-standard-skeleton-table
      [headers]="skeletonProps.headers"
      [tdAmount]="skeletonProps.tdAmount"
      [trAmount]="skeletonProps.trAmount"
    />
    <div
      data-qa="organization-overview-chart-expand-collapse-empty-state"
      class="min-h-[1rem] card">
    </div>
  </div>
} @else {
  <div class="vertical-container column-gap-1p25">
    <div class="table-fms">
      <table>
        <thead>
        <tr class="text-align-center">
          <th class="fix-w-2 first-level-left-sticky"></th>
          <th class="fix-w-13p75 second-level-left-sticky sticky-shadow-left"></th>
          <th colspan="6"></th>
          <th class="blank-space"></th>
          <th colspan="7">Before carry</th>
          <th class="blank-space"></th>
          <th colspan="3">Carried interest</th>
          <th class="blank-space"></th>
          <th colspan="6">After carry</th>
          <th colspan="100%"></th>
        </tr>
        <tr>
          <th id="three-dots-menu" class="fix-w-2 first-level-left-sticky">
            <app-three-dots-menu [matMenuTriggerFor]="menu"></app-three-dots-menu>
            <mat-menu #menu="matMenu">
              <ul class="list">
                <app-drop-down-item
                  data-qa="organization-excel"
                  class="width-100pcnt"
                  [text]="'Export'"
                  [iconNameAndStyling]="'excel.svg'"
                  (click)="exportExcel()">
                </app-drop-down-item>
              </ul>
            </mat-menu>
          </th>
          <th class="fix-w-13p75 second-level-left-sticky sticky-shadow-left">
            <div class="w-full h-full flex items-center gap-0.3125">
              <app-funds-selector-dropdown
                data-qa="org-overview-funds-selector-dropdown"
                [selectedFundsAmount]="selectedFundsAmount"
                [fundsData]="fundsData"
                (fundsDataChange)="fundsDataChangedByUser($event)"/>
              <span appSort
                [arr]="[fundsData.funds, fundsData.spvs]"
                [keySelector]="FundPerformanceOverviewSorting.byFundName">
              </span>
            </div>
          </th>
          <th
            class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byVintage">
            Vintage
          </th>
          <th class="fix-w-7p5">
            <app-input-date
              id="commonReportedPeriod"
              data-qa="change-period-for-all"
              [input]="commonReportedPeriod"
              [isShrinked]="true"
              [fontClass]="'caption-2'"
              (inputChange)="changeCommonReportedPeriod($event)"
              (mouseenter)="activateTooltip('commonReportedPeriod')"
              (mouseleave)="hideTooltip()"
            />
          </th>
          <th class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byTotalCommitment">
            Total commitment
          </th>
          <th class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byContributionReceived">
            Contribution received
          </th>
          <th class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byUnfundedCommitment">
            Unfunded commitment
          </th>
          <th>
            <div data-qa="nav-plus-unfunded-header"
              appSort
              [arr]="[fundsData.funds, fundsData.spvs]"
              [keySelector]="FundPerformanceOverviewSorting.bySumNavAndUnfundedCommitment"
              class="pd-right-0p345">
              <div class="flex flex-col fix-w-6p5">
                <span>AUM</span>
                <span>(NAV+Unf. Comm.)</span>
              </div>
            </div>
          </th>
          <th class="blank-space"></th>
          <th class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byNavAndDistribution">
            NAV & Distribution
          </th>
          <th class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byTotalNavInclCarry">
            <div class="flex flex-col">
              <span>NAV</span>
              <span class="bold400">Distr. incl carry</span>
            </div>
          </th>
          <th class="fix-w-7p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byNetGainLoss">
            Net gain/(loss)
          </th>
          <th class="fix-w-3p5"appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byTvpi">
            TVPI
          </th>
          <th class="fix-w-3p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byDpi">
            DPI
          </th>
          <th class="fix-w-3p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byRvpi">
            RVPI
          </th>
          <th class="fix-w-5p5" appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byNetIrr">
            Net IRR
          </th>
          <th class="blank-space"></th>
          <th class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byCarryInterestTotal">
            Total
          </th>
          <th class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byCarryInterestRealized">
            Realized
          </th>
          <th class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byCarryInterestUnrealized">
            Unrealized
          </th>
          <th class="blank-space"></th>
          <th class="fix-w-5p5"appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byNavAndDistributionAfterCarry">
            NAV & Distribution
          </th>
          <th class="fix-w-7p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byTotalNavInclCarryAfterCarry">
            <div class="flex flex-col">
              <span>NAV</span>
              <span class="bold400">Distr. w/o carry</span>
            </div>
          </th>
          <th class="fix-w-7p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byNetGainLossAfterCarry">
            Net gain/(loss)
          </th>
          <th class="fix-w-3p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byTvpiAfterCarry">
            TVPI
          </th>
          <th class="fix-w-3p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byDpiAfterCarry">
            DPI
          </th>
          <th class="fix-w-3p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byRvpiAfterCarry">
            RVPI
          </th>
          <th class="fix-w-5p5"
            appSort
            [arr]="[fundsData.funds, fundsData.spvs]"
            [keySelector]="FundPerformanceOverviewSorting.byNetIrrAfterCarry">
            Net IRR
          </th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngIf="!fundsData.all.length">
          <tr *ngFor="let i of [].constructor(selectedOrganization?.funds?.length)" app-table-empty-state
              class="animation-wrapper" [tdAmount]="23" [blankSpaceIndices]="[7, 15, 18, 24]">
          </tr>
        </ng-container>
        <ng-container *ngFor="let group of shownGroups">
          <tr *ngIf="selectedFundsAmount[group]" (click)="show[group] = !show[group]">
            <td class="first-level-left-sticky">
              <app-table-group-icon [opened]="show[group]"></app-table-group-icon>
            </td>
            <td class="second-level-left-sticky sticky-shadow-left bold600">
              {{group === 'funds' ? 'Funds' : 'SPVs'}}
            </td>
            <td colspan="6"></td>
            <td class="blank-space"></td>
            <td colspan="7"></td>
            <td class="blank-space"></td>
            <td></td>
            <td class="blank-space"></td>
            <td colspan="6"></td>
            <td colspan="100%"></td>
          </tr>
          <ng-container *ngFor="let f of fundsData[group]; let i = index">
            <ng-container *ngIf="show[group]">
              <ng-container *ngIf="f.isShown">
                <tr *ngIf="f.selectedFP">
                  <td class="first-level-left-sticky"></td>
                  <td class="second-level-left-sticky sticky-shadow-left">
                  <span
                    class="bold600 company-name"
                    [attr.data-qa]="'org-overview-name-' + f.name"
                    [id]="'fundName-'+i"
                    (mouseenter)="activateTooltip('fundName-' + i, f.name)"
                    (mouseleave)="hideTooltip()"
                    (click)="goToFundPerformance(f)">
                      {{f.name | linkShort: MAX_FUND_NAME_LEN}}
                    </span>
                  </td>
                  <td [attr.data-qa]="'org-overview-initial-closing-' + f.name">{{f.initialClosing | date:'yyyy' | dashInsteadOfNull}}</td>
                  <td>
                    <app-selector
                      [attr.data-qa]="'org-overview-periods-' + f.name"
                      [data]="f.periods"
                      [selectedItem]="f.selectedFP.period"
                      [outerClass]="'control-shrinked-container'"
                      [openOnClick]="true"
                      [blockRepositioning]="true"
                      (itemEmitter)="changePeriod($event, f)">
                    </app-selector>
                  </td>

                  <!-- Total commitment-->
                  <td [attr.data-qa]="'org-overview-commitment-' + f.name">{{f.selectedFP.totalCommitment | switcherDashBraces : numberSwitcher : 0}}</td>

                  <!-- Contribution received-->
                  <td [attr.data-qa]="'org-overview-contribution-' + f.name">
                    <div class="vertical-container-simple column-gap-0p25">
                    <span [attr.data-qa]="'org-overview-contribution-val-' + f.name">
                      {{f.selectedFP.contribution | switcherDashBraces : numberSwitcher : 0}}
                    </span>
                      <span [attr.data-qa]="'org-overview-contribution-pcnt-' + f.name" class="caption-3 bold500">
                      {{f.selectedFP.contribution / f.selectedFP.totalCommitment | percent: '1.2-2' | dashInsteadOfNull}}
                    </span>
                    </div>
                  </td>

                  <!-- Unfunded commitment -->
                  <td [attr.data-qa]="'org-overview-unf-com-' + f.name">{{f.selectedFP.totalCommitment - f.selectedFP.contribution | switcherDashBraces : numberSwitcher : 0}}</td>
                     <!--Nav + Unfunded commitment -->
                  <td [attr.data-qa]="'org-overview-unf-com-plus-nav' + f.name">
                    {{(f.selectedFP.totalCommitment - f.selectedFP.contribution) + (f.beforeCarry.navAndDistribution - f.beforeCarry.distribution) | switcherDashBraces : numberSwitcher : 0}}
                  </td>
                  <td class="blank-space"></td>
                  <!-- NAV +Distribution -->
                  <td [attr.data-qa]="'org-overview-before-carry-nav-' + f.name">{{f.beforeCarry.navAndDistribution | switcherDashBraces : 1 : 0}}</td>

                  <!-- Distribution incl. carry -->
                  <td>
                    <div class="flex flex-col gap-[0.25rem]">
                    <span [attr.data-qa]="'org-overview-before-carry-dist' + f.name">
                      {{(f.beforeCarry.navAndDistribution - f.beforeCarry.distribution) | switcherDashBraces : 1 : 0}}
                    </span>
                      <span [attr.data-qa]="'org-overview-before-carry-dist-val' + f.name" class="caption-3 bold500">
                      {{f.beforeCarry.distribution | switcherDashBraces : 1 : 0}}
                    </span>
                    </div>
                  </td>

                  <!-- Net gain loss before carry -->
                  <td  [attr.data-qa]="'org-overview-before-carry-ngl-' + f.name">{{f.beforeCarry.ngl | switcherDashBraces : numberSwitcher : 0 }}</td>

                  <!-- TVPI before carry -->
                  <td [attr.data-qa]="'org-overview-before-carry-tvpi-' + f.name">{{(f.beforeCarry.tvpi |switcherDashBraces : 1 : 2: false : 'x')}}</td>

                  <!-- DPI before carry -->
                  <td [attr.data-qa]="'org-overview-before-carry-dpi-' + f.name">{{(f.beforeCarry.dpi |switcherDashBraces : 1 : 2: false : 'x')}}</td>

                  <!-- RVPI before carry -->
                  <td [attr.data-qa]="'org-overview-before-carry-rvpi-' + f.name">{{(f.beforeCarry.rvpi |switcherDashBraces : 1 : 2: false : 'x')}}</td>

                  <!-- Net IRR before carry -->
                  <td>
                    <div class="space-between-horizontal-centered" [attr.data-qa]="'org-overview-before-carry-irr-' + f.name">
                      <ng-container *ngIf="f.selectedFP.netIrr !== null">
                        <span class="bold600">{{ f.selectedFP.netIrr | percent:'1.2-2' }}</span>
                        <app-all-icons
                          class="clickable"
                          [id]="'manual-' + group + '-' + i"
                          (mouseenter)="activateTooltip('manual-' + group + '-' + i)"
                          (mouseleave)="hideTooltip()"
                          [iconNameAndStyling]="'manual-circle.svg; main-9; icon-tiny-size'">
                        </app-all-icons>
                      </ng-container>
                      <ng-container *ngIf="f.selectedFP.netIrr === null">
                        {{ f.selectedFP.irrCalculated | percent:'1.2-2' }}
                      </ng-container>
                    </div>
                  </td>

                  <td class="blank-space"></td>

                  <!-- Carried interest -->
                  <td [attr.data-qa]="'org-overview-carry-' + f.name">{{f.selectedFP.carryInterest | switcherDashBraces : numberSwitcher : 0}}</td>
                  <td [attr.data-qa]="'org-overview-realized-carry--' + f.name">{{f.selectedFP.carryDistribution | switcherDashBraces : numberSwitcher : 0}}</td>
                  <td [attr.data-qa]="'org-overview-unrealized-carry-' + f.name">{{f.selectedFP.carryInterest + Math.abs(f.selectedFP.carryDistribution) | switcherDashBraces : numberSwitcher : 0}}</td>

                  <td class="blank-space"></td>

                  <!-- NAV +Distribution after carry-->
                  <td [attr.data-qa]="'org-overview-after-carry-nav-' + f.name">{{f.afterCarry.navAndDistribution | switcherDashBraces : numberSwitcher : 0}}</td>

                  <!-- Distribution after carry -->
                  <td>
                    <div class="flex flex-col gap-[0.25rem]">
                    <span [attr.data-qa]="'org-overview-after-carry-dist' + f.name">
                      {{(f.afterCarry.navAndDistribution - f.afterCarry.distribution) | switcherDashBraces : 1 : 0}}
                    </span>
                      <span [attr.data-qa]="'org-overview-after-carry-dist-val' + f.name" class="caption-3 bold500">
                      {{f.afterCarry.distribution | switcherDashBraces : 1 : 0}}
                    </span>
                    </div>
                  </td>

                  <!-- Net gain loss after carry -->
                  <td [attr.data-qa]="'org-overview-after-carry-ngl-' + f.name">{{f.afterCarry.ngl | switcherDashBraces : numberSwitcher : 0 }}</td>

                  <!-- TVPI after carry -->
                  <td [attr.data-qa]="'org-overview-after-carry-tvpi-' + f.name">{{(f.afterCarry.tvpi | switcherDashBraces : 1 : 2: false : 'x')}}</td>

                  <!-- DPI after carry-->
                  <td [attr.data-qa]="'org-overview-after-carry-dpi-' + f.name">{{ f.afterCarry.dpi | switcherDashBraces:1:2: false:'x' }}</td>

                  <!-- RVPI after carry-->
                  <td [attr.data-qa]="'org-overview-after-carry-rvpi-' + f.name">{{ f.afterCarry.rvpi | switcherDashBraces:1:2: false:'x' }}</td>

                  <!-- Net IRR after carry -->
                  <td>
                    <div class="space-between-horizontal-centered" [attr.data-qa]="'org-overview-after-carry-irr-' + f.name">
                      <ng-container *ngIf="f.selectedFP.netIrrAfterCarry !== null">
                        <span class="bold600">{{ f.selectedFP.netIrrAfterCarry | percent:'1.2-2' }}</span>
                        <app-all-icons
                          class="clickable"
                          [id]="'manualAfterCarry-'+i"
                          (mouseenter)="activateTooltip('manualAfterCarry-' + i)"
                          (mouseleave)="hideTooltip()"
                          [iconNameAndStyling]="'manual-circle.svg; main-9; icon-tiny-size'">
                        </app-all-icons>
                      </ng-container>
                      <ng-container *ngIf="f.selectedFP.netIrrAfterCarry === null">
                        {{ f.selectedFP.irrCalculatedAfterCarry | percent:'1.2-2' }}
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="selectedFundsAmount.funds && selectedFundsAmount.spvs">
            <ng-container *ngTemplateOutlet="totalsRow; context: { group: group, isSubtotal: true }"></ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="totalsRow; context: { totals: 'all', isSubtotal: false }"></ng-container>
        </tbody>
      </table>
    </div>
    <div class="vertical-container-simple">
        <div data-qa="organization-overview-chart-expand-collapse"
             class="start-row-container clickable row-gap-0p5 card"
             [class.no-bg]="show.chart"
             (click)="show.chart = !show.chart">
          <app-table-group-icon
            [opened]="show.chart">
          </app-table-group-icon>
          <span class="font-3 bold500">Chart</span>
        </div>
        <app-vertical-charts *ngIf="show.chart"
                             class="green-scroll"
                             [data]="graphicData">
        </app-vertical-charts>
    </div>
  </div>
}


<ng-template #totalsRow let-group="group" let-isSubtotal="isSubtotal">
  <ng-container *ngVar="group === shownGroups[0] ? totals.funds
                          : group === shownGroups[1] ? totals.spvs
                          : totals.all as total">
    <tr *ngIf="total" [ngClass]="isSubtotal ? 'total' : 'grand-total'">
      <td class="first-level-left-sticky"></td>
      <td class="bold600 second-level-left-sticky sticky-shadow-left">{{ isSubtotal ? 'Subtotal' : 'Total' }}</td>
      <td colspan="2"></td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-commitment-' + group : 'total-commitment'">{{total.totalCommitment | switcherDashBraces : numberSwitcher : 0}}</td>
      <td>
        <div class="vertical-container-simple column-gap-0p25">
          <span [attr.data-qa]="isSubtotal ? 'subtotal-contribution-value-' + group : 'total-contribution-value'">{{total.contributionReceivedNumber | switcherDashBraces : numberSwitcher : 0}}</span>
          <span class="caption-3 bold600" [attr.data-qa]="isSubtotal ? 'subtotal-contribution-pcnt-' + group : 'total-contribution-pcnt'">
          {{((total.contributionReceivedNumber / total.totalCommitment) * 100) | switcherDashBraces : 1 : 2: false : '' : '%'}}
        </span>
        </div>
      </td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-unfunded-' + group : 'total-unfunded'">
        {{total.totalCommitment - total.contributionReceivedNumber | switcherDashBraces : numberSwitcher : 0}}
      </td>
          <!--Nav + Unfunded commitment -->
          <td [attr.data-qa]="isSubtotal ? 'subtotal-unfunded-plus-nav' + group : 'total-unfunded-plus-nav'">
            {{(total.totalCommitment - total.contributionReceivedNumber) + (total.beforeCarry.navAndDistribution - total.beforeCarry.distribution ) | switcherDashBraces : numberSwitcher : 0}}
          </td>
      <td class="blank-space"></td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-before-nav-' + group : 'total-before-nav'">
        {{total.beforeCarry.navAndDistribution | switcherDashBraces : numberSwitcher : 0}}
      </td>
      <td>
        <div class="flex flex-col gap-[0.25rem]">
          <span [attr.data-qa]="isSubtotal ? 'subtotal-before-nav-' + group : 'total-before-nav'">
            {{total.beforeCarry.navAndDistribution - total.beforeCarry.distribution | switcherDashBraces : numberSwitcher : 0}}
          </span>
          <span [attr.data-qa]="isSubtotal ? 'subtotal-before-dist-' + group : 'total-before-dist'" class="caption-3 bold600">
            {{total.beforeCarry.distribution | switcherDashBraces : numberSwitcher : 0}}
          </span>
        </div>
      </td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-before-ngl-' + group : 'total-before-ngl'">{{total.beforeCarry.ngl | switcherDashBraces : numberSwitcher : 0}}</td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-before-tvpi-' + group : 'total-before-tvpi'">{{total.beforeCarry.tvpi | switcherDashBraces : 1 : 2: false : 'x'}}</td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-before-dpi-' + group : 'total-before-dpi'">{{total.beforeCarry.dpi | switcherDashBraces : 1 : 2: false : 'x'}}</td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-before-rvpi-' + group : 'total-before-rvpi'">{{total.beforeCarry.rvpi | switcherDashBraces : 1 : 2: false : 'x'}}</td>
      <td></td>
      <td class="blank-space"></td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-carry-' + group : 'total-carry-'">{{total.carriedInterest.total | switcherDashBraces : numberSwitcher : 0}}</td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-realized-carry-' + group : 'total-realized-carry-'">{{total.carriedInterest.realized | switcherDashBraces : numberSwitcher : 0}}</td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-unrealized-carry-' + group : 'total-unrealized-carry-'">{{total.carriedInterest.unrealized | switcherDashBraces : numberSwitcher : 0}}</td>
      <td class="blank-space"></td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-after-nav-' + group : 'total-after-nav'">{{total.afterCarry.navAndDistribution | switcherDashBraces : numberSwitcher : 0}}</td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-after-dist-' + group : 'total-after-dist'">
        <div class="flex flex-col gap-[0.25rem]">
          <span [attr.data-qa]="isSubtotal ? 'subtotal-after-nav-' + group : 'total-after-nav'">
            {{total.afterCarry.navAndDistribution - total.afterCarry.distribution | switcherDashBraces : numberSwitcher : 0}}
          </span>
          <span [attr.data-qa]="isSubtotal ? 'subtotal-after-dist-' + group : 'total-after-dist'" class="caption-3 bold600">
            {{total.afterCarry.distribution | switcherDashBraces : numberSwitcher : 0}}
          </span>
        </div>
      </td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-after-ngl-' + group : 'total-after-ngl'">{{total.afterCarry.ngl | switcherDashBraces : numberSwitcher : 0}}</td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-after-tvpi-' + group : 'total-after-tvpi'">{{total.afterCarry.tvpi | switcherDashBraces : 1 : 2: false : 'x'}}</td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-after-dpi-' + group : 'total-after-dpi'">{{total.afterCarry.dpi | switcherDashBraces : 1 : 2: false : 'x'}}</td>
      <td [attr.data-qa]="isSubtotal ? 'subtotal-after-rvpi-' + group : 'total-after-rvpi'">{{total.afterCarry.rvpi | switcherDashBraces : 1 : 2: false : 'x'}}</td>
      <td></td>
    </tr>
  </ng-container>
</ng-template>

<app-tooltip
  *ngIf="toolTipSettings?.show"
  [positionType]="isToolTipForFundName ? 'left' : 'centered'"
  [coordinates]="toolTipSettings.coordinates"
  [title]="toolTipSettings.title">
</app-tooltip>
